"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StaticMap = function StaticMap(_ref) {
  var searchLocation = _ref.searchLocation,
      jobLocation = _ref.jobLocation,
      discriminator = _ref.discriminator,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'map' : _ref$id,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? false : _ref$width;
  // we need the discriminator for marker image path
  var pcMarker = "".concat(discriminator || 'truck', "-pc-map-marker.png");
  var bcMarker = "".concat(discriminator || 'truck', "-bc-map-marker.png");

  var getMapUrl = function getMapUrl(search, job) {
    var checkDefaultCoord = function checkDefaultCoord(lat, long) {
      if (parseInt(lat) === 10 && parseInt(long) === 55) {
        return true;
      } else {
        return false;
      }
    }; // For Offer Preview the PC user's position should not be far from the BC position


    var longitude = checkDefaultCoord(search && search.longitude, search && search.latitude) ? parseFloat(job.longitude) + 0.0905 : search && search.longitude;
    var latitude = checkDefaultCoord(search && search.longitude, search && search.latitude) ? parseFloat(job.latitude) + 0.1505 : search && search.latitude;
    var pcUrlPart = discriminator !== 'service-gastro' ? "&markers=scale:".concat(small ? 2 : 1, "%7Canchor:bottomcenter%7Cicon:https://s3.amazonaws.com/matching-public/").concat(pcMarker, "%7C").concat(latitude, ",").concat(longitude) : '';
    var bcUrlPart = "&markers=scale:".concat(small ? 2 : 1, "%7Canchor:bottomcenter%7Cicon:https://s3.amazonaws.com/matching-public/").concat(bcMarker, "%7C").concat(job.latitude, ",").concat(job.longitude);
    return search ? "https://maps.googleapis.com/maps/api/staticmap?scale=2&size=600x".concat(small ? 150 : 600).concat(search.longitude && search.latitude ? pcUrlPart : '').concat(bcUrlPart, "&key=AIzaSyCxmKwdELLdYWxlOEzvYnMcNsrJXENF8Dg&sensor=false") : "https://maps.googleapis.com/maps/api/staticmap?scale=2&size=600x".concat(small ? 150 : 600, "&markers=scale:").concat(small ? 2 : 1, "%7Canchor:bottomcenter%7Cicon:https://s3.amazonaws.com/matching-public/").concat(bcMarker, "%7C").concat(job.latitude, ",").concat(job.longitude, "&key=AIzaSyCxmKwdELLdYWxlOEzvYnMcNsrJXENF8Dg&sensor=false");
  };

  var src = getMapUrl(searchLocation, jobLocation);
  return width ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    id: id,
    src: src,
    alt: "Map",
    width: width
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    id: id,
    src: src,
    alt: "Map"
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(StaticMap);

exports.default = _default;